<template>
  <div class="animated revealUp">
    <div class="section-title mb-3">
      {{ $t("edit") }} {{ $t("fnbDynamicPricing") }}
    </div>
    <section class="white-wrapper">
      <form class="row">
        <div class="col-lg-6 col-xl-3 align-self-center">
          <div class="d-flex align-items-center">
            <div class="dropdown-curve-container">
              <label :class="selectedCinema.length > 0 ? 'shift-up' : ''">{{
                $tc("cinema", 2)
              }}</label>
              <b-dropdown
                :disabled="isRoleID"
                :text="selectedCinema"
                variant="dropdown-curve"
                class="w-100"
              >
                <div class="px-2 pb-2">
                  <input
                    required
                    autofocus
                    type="search"
                    placeholder="Search Cinema"
                    class="form-control form-control-sm"
                    v-on:keyup="onSearchCinema($event.target.value)"
                    v-on:keydown="onSearchCinema($event.target.value)"
                    v-model="searchCinema"
                  />
                </div>
                <b-dropdown-item
                  v-for="(cinema, cinemaIndex) in Cinemas"
                  :key="cinemaIndex"
                  v-on:click="onSelectCinema(cinema)"
                  >{{ cinema.cine_name }}</b-dropdown-item
                >
              </b-dropdown>
            </div>
          </div>
          <p class="error_message">
            <span v-if="submitted && selectedCinema.length == 0"
              >Please select cinema.</span
            >
          </p>
        </div>

        <div class="col-lg-3 col-xl-3 align-self-center">
          <div class="d-flex align-items-center">
            <div class="input-material">
              <input
                placeholder="."
                type="text"
                v-model="fdp_name"
                name="pricing_name"
                id="pricing_name"
                v-validate="{ required: 'required', regex: /^[a-zA-Z0-9 ]*$/ }"
              />
              <label>{{ $t("fdpName") }}</label>
            </div>
          </div>
          <p class="error_message">
            <span v-if="submitted && errors.has('pricing_name')">{{
              errors.first("pricing_name")
            }}</span>
          </p>
        </div>

        <div class="col-lg-3 col-xl-3 align-self-center">
          <div class="d-flex align-items-center">
            <div class="input-material">
              <input
                placeholder="."
                type="text"
                v-model="fdp_description"
                name="Pricing Description"
                id="Pricing Description"
              />
              <label>{{ $t("fdpDescription") }}</label>
            </div>
          </div>
          <p class="error_message">
            <span></span>
          </p>
        </div>

        <div class="col-lg-3 col-xl-3 d-flex align-items-center pb-3">
          <b-form-checkbox
            v-model="fdp_is_active"
            type="checkbox"
            class="j-checkbox pb-0 mb-0"
            checked
          />

          <label class="mb-0 mr-2">{{ $t("active") }}</label>
        </div>

        <div class="col-lg-6 col-xl-3 mb-4">
          <div class="input-material">
            <div class="add-datepicker">
              <button
                v-if="from_date_time"
                v-on:click="clearFromDate()"
                class="btn-clearDate"
              >
                ✖
              </button>
              <Datepicker
                :monday-first="true"
                ref="programaticOpen"
                v-model="from_date_time"
                type="date"
                class="theme-custom-date-time"
                typeable
                v-validate="'required'"
                id="fromd"
                name="fromd"
              ></Datepicker>
              <label :class="from_date_time ? 'active' : ''">{{
                $t("fromdate")
              }}</label>
            </div>
          </div>
          <p class="error_message">
            <span v-if="submitted && errors.has('fromd')">{{
              errors.first("fromd")
            }}</span>
          </p>
        </div>

        <div class="col-lg-6 col-xl-3 mb-4">
          <div class="input-material">
            <div class="add-datepicker">
              <button
                v-if="to_date_time"
                v-on:click="clearToDate()"
                class="btn-clearDate"
              >
                ✖
              </button>
              <Datepicker
                :monday-first="true"
                ref="programaticOpen"
                v-model="to_date_time"
                type="date"
                class="theme-custom-date-time"
                typeable
                v-validate="'required'"
                id="todate"
                name="todate"
              ></Datepicker>
              <label :class="to_date_time ? 'active' : ''">{{
                $t("todate")
              }}</label>
            </div>
          </div>
          <p class="error_message">
            <span v-if="submitted && errors.has('todate')">{{
              errors.first("todate")
            }}</span>
          </p>
        </div>

        <div class="col-lg-6 col-xl-3 mb-4 custom-timepicker">
          <div class="input-material">
            <div class="add-datepicker">
              <vue-timepicker
                manual-input
                v-model="startTime2"
                id="starttime"
                name="starttime"
                placeholder="Start Time"
                format="HH:mm"
                class="time_picker"
                input-width="100%"
                auto-scroll
                v-validate="'required'"
              ></vue-timepicker>
              <label :class="startTime2 ? 'active' : 'in-active'">{{
                $t("fromtime")
              }}</label>
            </div>
          </div>
          <p class="error_message">
            <span v-if="submitted && errors.has('starttime')">{{
              errors.first("starttime")
            }}</span>
          </p>
        </div>

        <div class="col-lg-6 col-xl-3 mb-4 custom-timepicker">
          <div class="input-material">
            <div class="add-datepicker">
              <vue-timepicker
                manual-input
                v-model="endTime2"
                id="endtime"
                name="endtime"
                placeholder="End Time"
                format="HH:mm"
                class="time_picker"
                input-width="100%"
                auto-scroll
                v-validate="'required'"
              ></vue-timepicker>
              <label :class="endTime2 ? 'active' : 'in-active'">{{
                $t("totime")
              }}</label>
            </div>
          </div>
          <p class="error_message">
            <span v-if="submitted && errors.has('endtime')">{{
              errors.first("endtime")
            }}</span>
          </p>
        </div>

        <!-- DAYS -->
        <div class="row ml-5 mb-2">
          <div class="col-lg-12 col-xl-12 pl-0">
            <div class="row">
              <div class="mr-5" style="color: black">{{ $t("days") }}:</div>
              <!--{{ $t("select") }}-->
              <b-form-checkbox
                v-for="(weekdaysLoop, weekdaysKey) in weekDays"
                :key="weekdaysKey"
                style="min-width: 125px"
                class="j-checkbox mb-3"
                @change="onChangeWeekdays($event, weekdaysKey)"
                v-model="weekDays[weekdaysKey]"
              >
                <div class="text-capitalize">{{ weekdaysKey }}</div>
              </b-form-checkbox>
            </div>
          </div>
        </div>

        <div class="col-md-12 mb-3 font-weight-bold">{{ $t("items") }}</div>

        <div
          v-for="(item, pricingIndex) in fnbItems"
          :key="pricingIndex"
          class="col-md-12 mb-4"
        >
          <div class="row" style="border-bottom: 0.1px solid lightgrey">
            <div class="col-11">
              <div class="row mx-auto">
                <div class="col-md-4">
                  <div class="d-flex align-items-center">
                    <div class="dropdown-curve-container">
                      <label
                        :class="
                          item.item_name && item.item_name.length > 0
                            ? 'shift-up'
                            : ''
                        "
                        >{{ $t("fnbitems") }}</label
                      >
                      <b-dropdown
                        :text="item.item_name"
                        variant="dropdown-curve"
                        class="w-100"
                      >
                        <div class="px-2 pb-2">
                          <input
                            required
                            autofocus
                            type="search"
                            placeholder="Search Fnb"
                            class="form-control form-control-sm"
                            v-on:keyup="onSearchFnb($event.target.value)"
                            v-on:keydown="onSearchFnb($event.target.value)"
                            v-model="searchFnb"
                          />
                        </div>
                        <b-dropdown-item
                          v-for="(fnbItem, fnbItemIndex) in FnbList"
                          :key="fnbItemIndex"
                          v-on:click="onSelectFnb(fnbItem, pricingIndex)"
                          >{{ fnbItem.item_name }}</b-dropdown-item
                        >
                      </b-dropdown>
                    </div>
                  </div>
                  <p class="error_message">
                    <span v-if="submitted && item.item_name.length == 0"
                      >Please select f&b item.</span
                    >
                  </p>
                </div>

                <div class="col-md-3 align-self-center">
                  <div class="d-flex align-items-center">
                    <div class="input-material">
                      <input
                        placeholder="."
                        type="text"
                        disabled
                        v-model="item.old_item_gross_price"
                      />
                      <label>{{ $t("oldGrossPrice") }}</label>
                    </div>
                  </div>
                  <p class="error_message">
                    <span></span>
                  </p>
                </div>

                <div class="col-md-3 align-self-center">
                  <div class="d-flex align-items-center">
                    <div class="input-material">
                      <input
                        placeholder="."
                        type="text"
                        @keydown="
                          onEnterFnbSellingPrice(
                            $event.target.value,
                            pricingIndex
                          )
                        "
                        @keyup="
                          onEnterFnbSellingPrice(
                            $event.target.value,
                            pricingIndex
                          )
                        "
                        name="new_item_price"
                        id="new_item_price"
                        v-validate="'required|decimal'"
                        v-model="item.fnb_final_price"
                      />
                      <label>{{ $t("newGrossPrice") }}</label>
                    </div>
                  </div>
                  <p class="error_message">
                    <span v-if="submitted && errors.has('new_item_price')">{{
                      errors.first("new_item_price")
                    }}</span>
                  </p>
                </div>

                <div class="col-md-2 align-self-center">
                  <div class="d-flex align-items-center">
                    <div class="input-material">
                      <input
                        placeholder="."
                        type="text"
                        disabled
                        v-model="item.difference"
                      />
                      <label>{{ $t("discount") }}</label>
                    </div>
                  </div>
                  <p class="error_message">
                    <span></span>
                  </p>
                </div>

                <div class="col-md-1 align-self-center" v-if="false">
                  <div class="d-flex align-items-center">
                    <div class="input-material">
                      <input
                        placeholder="."
                        type="text"
                        disabled
                        v-model="item.fnb_tax_price"
                      />
                      <label>{{ $t("tax") }} {{ $t("amount") }}</label>
                    </div>
                  </div>
                  <p class="error_message">
                    <span></span>
                  </p>
                </div>

                <div class="col-md-2 align-self-center" v-if="false">
                  <div class="d-flex align-items-center">
                    <div class="input-material">
                      <input
                        placeholder="."
                        type="number"
                        disabled
                        v-model="item.fnb_final_price"
                      />
                      <label>{{ $t("selling") }} {{ $tc("price", 1) }}</label>
                    </div>
                  </div>
                  <p class="error_message">
                    <span></span>
                  </p>
                </div>
              </div>
            </div>
            <div
              class="col-lg-1 border-left d-flex align-items-center justify-content-center mb-2"
            >
              <button
                v-if="pricingIndex === 0"
                @click.prevent.stop="addDay()"
                class="btn-transparent"
              >
                <img src="@/assets/img/icons/plus.svg" height="35" width="35" />
              </button>
              <button
                v-else
                @click.prevent.stop="removeDay(pricingIndex, item)"
                class="btn-transparent"
              >
                <img
                  src="@/assets/img/icons/minus.svg"
                  height="35"
                  width="35"
                />
              </button>
            </div>
          </div>
        </div>

        <div class="col-md-12 mb-4 text-center">
          <button
            :disabled="btenable"
            @click.prevent.stop="onFinalSubmit()"
            class="btn-blue"
          >
            {{ $t("update") }}</button
          >&nbsp;
          <router-link to="fnb-dynamic-pricing" class="btn-outline-blue">{{
            $t("cancel")
          }}</router-link>
        </div>
      </form>
    </section>
  </div>
</template>

<script>
import MasterService from "@/services/MasterService";
import CinemasService from "@/services/CinemasService";
import MarketingService from "@/services/MarketingService";
import ExhibitorService from "@/services/ExhibitorService";
import moment from "moment";
import DatePicker from "vue2-datepicker";
import VueTimepicker from "vue2-timepicker";
import "vue2-timepicker/dist/VueTimepicker.css";

export default {
  components: { DatePicker, VueTimepicker },
  data() {
    return {
      btenable: false,
      isRoleID: true,
      submitted: false,

      searchCinema: "",
      searchFnb: "",
      searchRateCard: "",
      fdp_common_id: null,
      fdp_is_active: true,
      fdp_name: "",
      fdp_description: "",
      from_date_time: null,
      to_date_time: null,
      startTime2: "",
      endTime2: "",
      cinema_id: null,
      weekDays: {
        selectAll: false,
        sunday: false,
        monday: false,
        tuesday: false,
        wednesday: false,
        thursday: false,
        friday: false,
        saturday: false,
      },
      Days: [
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday",
        "Sunday",
      ],
      FnbList: [],
      FnbListCopy: [],
      // RateCardList: [],
      // RateCardListCopy: [],
      fnbItems: [
        {
          fdp_id: null,
          item_id: null,
          item_name: "",
          old_item_price: 0,
          old_item_gross_price: 0,
          item_price: 0,
          difference: 0,
          fnb_tax_price: 0,
          fnb_final_price: 0,
        },
      ],
      Cinemas: [],
      CinemasCopy: [],
      selectedCinema: "",
      TrueFalseCount: 0,
      removedItems: [],
    };
  },
  beforeMount() {
    let obj = this.secureStore.get("USINFO").cinema_id;
    let roleid = this.secureStore.get("USINFO").role_id;
    this.fdp_common_id = this.$route.query.fdp_common_id;
    if (this.fdp_common_id) {
      this.getDynamicPricingDetails();
    }
    if (true) {
      this.isRoleID = false;
    }
    this.getCinemasList(obj);
  },
  methods: {
    clearFromDate() {
      this.from_date_time = null;
    },
    clearToDate() {
      this.to_date_time = null;
    },
    onSearchCinema: function (value) {
      if (this.searchCinema && this.searchCinema.length > 0) {
        this.Cinemas = this.CinemasCopy.filter((x) => {
          if (
            x.cine_name.toLowerCase().includes(this.searchCinema.toLowerCase())
          ) {
            return x;
          }
        });
      } else {
        this.Cinemas = this.CinemasCopy;
      }
    },
    onSearchFnb: function (value) {
      if (this.searchFnb && this.searchFnb.length > 0) {
        this.FnbList = this.FnbListCopy.filter((x) => {
          if (
            x.item_name.toLowerCase().includes(this.searchFnb.toLowerCase())
          ) {
            return x;
          }
        });
      } else {
        this.FnbList = this.FnbListCopy;
      }
    },
    // onSearchCinema: function(value) {
    //   if (this.searchRateCard && this.searchRateCard.length > 0) {
    //     this.RateCardList = this.RateCardListCopy.filter(x => {
    //       if (
    //         x.rc_name.toLowerCase().includes(this.searchRateCard.toLowerCase())
    //       ) {
    //         return x;
    //       }
    //     });
    //   } else {
    //     this.RateCardList = this.RateCardListCopy;
    //   }
    // },
    getDynamicPricingDetails: function () {
      let Records = [];
      let payload = {
        fdp_common_id: this.fdp_common_id,
      };
      ExhibitorService.GetSingleFnbDynamicPricing(payload)
        .then((response) => {
          const { data } = response;
          Records = data.Records;
          if (data.status && data.Records.length > 0) {
            let obj = data.Records[0];
            for (var i = 0; i < data.Records.length - 1; i++) {
              this.addDay();
            }
            this.cinema_id = obj.cinema_id;
            this.getActiveFnbList(obj.cinema_id);
            // this.getActiveRateCardList(obj.cinema_id);
            this.selectedCinema = obj.cine_name;
            this.fdp_name = obj.fdp_name;
            this.fdp_description = obj.fdp_description;
            this.from_date_time = obj.from_date_time;
            this.to_date_time = obj.to_date_time;
            this.startTime2 = moment(obj.from_date_time).format("HH:mm");
            this.endTime2 = moment(obj.to_date_time).format("HH:mm");
            data.Records.map((x, index) => {
              this.setDaysValue(x, index);
              this.fnbItems[index].fdp_id = x.fdp_id;
              this.fnbItems[index].item_id = x.item_id;
              this.fnbItems[index].old_item_price = +parseFloat(
                x.fp_amount
              ).toFixed(this.MIN_FRACTION_DIGITS);
              this.fnbItems[index].old_item_gross_price = parseFloat(
                x.fp_total_amount
              ).toFixed(this.MIN_FRACTION_DIGITS);
              this.fnbItems[index].item_price = +parseFloat(
                x.item_price
              ).toFixed(this.MIN_FRACTION_DIGITS);
              this.getTaxAmount(x.item_id, index, true);
              this.fnbItems[index].difference =
                x.item_price && String(x.item_price).length > 0
                  ? parseFloat(
                      parseFloat(x.fp_amount) - parseFloat(x.item_price) > 0
                        ? parseFloat(x.fp_amount) - parseFloat(x.item_price)
                        : 0
                    ).toFixed(this.MIN_FRACTION_DIGITS)
                  : 0;
              this.fnbItems[index].item_name = x.item_name;
            });
            this.fdp_is_active = obj.fdp_is_active == "Y" ? true : false;
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError)
        .finally(() => {
          // setTimeout(() => {
          //   this.fnbItems.map((x, index) => {
          //     this.fnbItems[index].fnb_final_price =
          //       parseFloat(parseFloat(x.fnb_tax_price) + parseFloat(x.item_price)).toFixed(this.MIN_FRACTION_DIGITS);
          //   });
          // }, 100);
        });
    },
    setDaysValue: function (activeDays, index) {
      let days = {
        sunday: "fdp_is_sunday",
        monday: "fdp_is_monday",
        tuesday: "fdp_is_tuesday",
        wednesday: "fdp_is_wednesday",
        thursday: "fdp_is_thursday",
        friday: "fdp_is_friday",
        saturday: "fdp_is_saturday",
      };
      if (activeDays) {
        Object.keys(days).map((x) => {
          this.weekDays[x] = activeDays[days[x]] === "Y" ? true : false;
        });

        let array = Object.keys(this.weekDays).filter(
          (x) => x !== "selectAll" && !this.weekDays[x]
        );
        if (array.length === 0) {
          this.weekDays["selectAll"] = true;
        }
      }
    },
    getCinemasList: function (cine_id) {
      // let payload = {
      //   tableName: "ms_cinemas",
      //   cine_is_active: "Y"
      // };
      MasterService.GetCinemas({ cine_id: cine_id })
        .then((response) => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.Cinemas = data.Records;
            this.CinemasCopy = data.Records;
            // this.Cinemas.map(x => {
            //   if (String(cine_id) === String(x.cine_id)) {
            //     this.selectedCinema = x.cine_name;
            //   }
            // });
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError);
    },

    // onSelectDay: function(day, index) {
    //   this.pricingList[index].day = day;
    // },

    onSelectCinema: function (params) {
      this.selectedCinema = params.cine_name;
      this.cinema_id = params.cine_id;
      this.getActiveFnbList();
      // this.getActiveRateCardList(params.cine_id);
    },

    getActiveFnbList: function (cinema_id) {
      this.FnbList = [];
      ExhibitorService.GetAllActiveFnbItems({ cinema_id })
        .then((response) => {
          const { data } = response;
          if (data && data.status && data.Records) {
            this.FnbList = data.Records;
            this.FnbListCopy = data.Records;
          } else {
            this.$toasted.show(data.message || "Opps! Something went wrong");
          }
        })
        .catch(this._CatchError);
    },
    onChangeWeekdays: function (event, keyname) {
      this.TrueFalseCount = 0;
      if (keyname !== "selectAll") {
        this.weekDays["selectAll"] = false;
        this.weekDays[keyname] = event;
      }

      let len = Object.keys(this.weekDays).length;
      if (keyname === "selectAll" && event) {
        Object.keys(this.weekDays).map((x) => {
          x !== "selectAll" ? (this.weekDays[x] = true) : "";
        });
      } else if (keyname === "selectAll" && !event) {
        Object.keys(this.weekDays).map((x) => {
          x !== "selectAll" ? (this.weekDays[x] = false) : "";
        });
      } else if (keyname !== "selectAll" && this.weekDays.selectAll) {
        this.weekDays["selectAll"] = false;
      }

      Object.keys(this.weekDays).map((x) => {
        if (x != "selectAll") {
          if (this.weekDays[x] === false) {
            this.TrueFalseCount++;
          }
        }
      });
    },
    // getActiveRateCardList: function(cinema_id) {
    //   this.RateCardList = [];
    //   let payload = {
    //     limit: null,
    //     currentPage: null,
    //     cinema_id: cinema_id,
    //     searchValue: null,
    //     searchKey: null
    //   };
    //   CinemasService.GetRatecardsList(payload)
    //     .then(response => {
    //       const { data } = response;
    //       if (data && data.status) {
    //         if (data.Records.length > 0) {
    //           this.RateCardList = data.Records;
    //           this.RateCardListCopy = data.Records;
    //         }
    //       } else {
    //         this.$toasted.show(data.message);
    //       }
    //     })
    //     .catch(this._CatchError); //message
    // },

    // onTimeHandler: function(value, type, index) {
    //   let time = moment(value).format("HH:mm");
    //   if (type == "fromTime") {
    //     this.pricingList[index]["fromTime"] = time;
    //   } else if (type == "toTime") {
    //     this.pricingList[index]["toTime"] = time;
    //   }
    // },

    onSelectFnb(item, index) {
      this.fnbItems[index].item_id = item.item_id;
      this.fnbItems[index].item_name = item.item_name;
      this.fnbItems[index].old_item_price = parseFloat(item.fp_amount || 0);
      this.fnbItems[index].old_item_gross_price = parseFloat(
        item.fp_total_amount || 0
      ).toFixed(this.MIN_FRACTION_DIGITS);
      this.getTaxAmount(item.item_id, index);
    },

    getTaxAmount: function (item_id, index, calculateFinal = false) {
      let payload = {
        item_id: item_id,
        cinema_id: this.cinema_id,
      };
      ExhibitorService.GetFnbTaxPrice(payload)
        .then((response) => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            this.fnbItems[index].fnb_tax_price = 0;
            data.Records.map((x) => {
              console.log("x.frcs_amount :>> ", x.frcs_amount);
              this.fnbItems[index].fnb_tax_price += x.frcs_amount;
              console.log(
                "this.fnbItems[index].fnb_tax_price :>> ",
                this.fnbItems[index].fnb_tax_price
              );
            });
            if (calculateFinal) {
              this.fnbItems[index].fnb_final_price = parseFloat(
                parseFloat(this.fnbItems[index].fnb_tax_price) +
                  parseFloat(this.fnbItems[index].item_price)
              ).toFixed(this.MIN_FRACTION_DIGITS);
            }
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch((err) => {
          this.$toasted.show(err);
        });
    },

    onEnterFnbSellingPrice(value, index) {
      this.fnbItems[index].fnb_final_price = value;
      let net_amount = parseFloat(
        parseFloat(value || 0) -
          parseFloat(this.fnbItems[index].fnb_tax_price || 0)
      );
      this.fnbItems[index].item_price = net_amount;
      this.fnbItems[index].difference = parseFloat(
        parseFloat(this.fnbItems[index].old_item_price) - net_amount > 0
          ? parseFloat(this.fnbItems[index].old_item_price) - net_amount
          : 0
      ).toFixed(this.MIN_FRACTION_DIGITS);
    },

    onChangeItemPrice: function (value, index) {
      this.fnbItems[index].item_price = value;
      this.fnbItems[index].difference = parseFloat(
        this.fnbItems[index].old_item_price - value
      ).toFixed(this.MIN_FRACTION_DIGITS);
      this.fnbItems[index].fnb_final_price =
        parseFloat(this.fnbItems[index].fnb_tax_price) + parseFloat(value);
    },

    // onSelectRateCard(rateCard, index) {
    //   this.pricingList[index].rc_id = rateCard.rc_id;
    //   this.pricingList[index].rc_name = rateCard.rc_name;
    // },

    addDay: function () {
      this.fnbItems.push({
        fdp_id: null,
        item_id: null,
        item_name: "",
        old_item_price: 0,
        old_item_gross_price: 0,
        item_price: 0,
        difference: 0,
        fnb_tax_price: 0,
        fnb_final_price: 0,
      });
    },
    removeDay: function (index, item) {
      if (
        this.removedItems &&
        this.removedItems.length > 0 &&
        !this.removedItems.some((x) => x.item_id == item.item_id)
      ) {
        this.removedItems.push(item);
      }
      this.fnbItems.splice(index, 1);
    },
    ItemValidation: function () {
      let count = 0;

      this.fnbItems.map((x) => {
        if (x.item_id == null) {
          count++;
        }
      });

      if (count > 0) {
        return true;
      } else {
        return false;
      }
    },
    convertTime(date, time) {
      const d = moment(date).format("YYYY-MM-DD");
      const newdate = moment(d + " " + time).format("YYYY-MM-DD HH:mm");
      return newdate;
    },
    onFinalSubmit: function () {
      this.submitted = true;

      if (
        new Date(moment(this.from_date_time).format("YYYY-MM-DD")) >
        new Date(moment(this.to_date_time).format("YYYY-MM-DD"))
      ) {
        return this.$toasted.show(
          "From date should not be greater than To date."
        );
      }
      this.$validator.validate().then((valid) => {
        if (this.cinema_id == null) {
          return;
        } else if (Object.keys(this.weekDays).every((k) => !this.weekDays[k])) {
          return;
        } else if (this.ItemValidation()) {
          return;
        } else if (valid) {
          let loader = this.$loading.show();
          this.btenable = true;
          let payload = {
            fdp_common_id: this.fdp_common_id,
            cinema_id: this.cinema_id,
            weekDays: this.weekDays,
            fdp_name: this.fdp_name,
            fdp_description: this.fdp_description,
            fdp_is_active: this.fdp_is_active,
            fromDateTime: this.convertTime(
              this.from_date_time,
              this.startTime2
            ),
            toDateTime: this.convertTime(this.to_date_time, this.endTime2),
            fnbItems: this.fnbItems,
            removedItems: this.removedItems,
          };
          ExhibitorService.EditDynamicPricing(payload)
            .then((response) => {
              this.btenable = false;
              const { data } = response;
              if (data && data.status) {
                this.$toasted.show(data.message);

                this.$router.push({
                  path: "fnb-dynamic-pricing",
                });
              } else {
                this.$toasted.show(data.message);
              }
            })
            .catch(this._CatchError)
            .finally(() => {
              setTimeout(() => loader.hide(), 1000);
            });
        }
      });
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/Pages/ExhibitorManagement/FnbDynamicPricing/editFnbDynamicPricing.vue